import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-performance-container.css.lit';
// import { OutlineContent } from '../../base/outline-content-card/outline-content-card';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { classMap } from 'lit/directives/class-map.js';
import { SlotController } from '../../controllers/slot-controller';
import { SlotsController } from '../../controllers/slots-controller';

interface Indicator {
  label: string;
  value: string;
  status: string;
  icon: string;
}

/**
 * The IDB performance Container component.
 * @element idb-performance-container
 */
@customElement('idb-performance-container')
export class IdbPerformanceContainer extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  slots = new SlotController(this, false);

  slotsFancy = new SlotsController(this);

  @property({ type: String, attribute: 'link-url' })
  url: String = '#';

  @property({ type: String, attribute: 'link-text' })
  linkText: String = '';

  @property({ type: Array, attribute: 'indicators' })
  indicators: Indicator[] = [];

  render(): TemplateResult {
    const containerClasses = {
      container: true,
    };

    const contentWrapperClasses = {
      'container-content-wrapper': true,
    };

    return html`
      <section class="${classMap(containerClasses)}">
        <section class="${classMap(contentWrapperClasses)}">
          <section class="cta">
            <idb-button class="mr-2" button-variant="inherit" button-url="${
              this.url
            }" icon-right="chevron-right">${this.linkText}</idb-button>
          </section>
          ${this.slotsFancy.renderInShadow('content')}
          ${this.slotsFancy.renderInShadow('footer')}
        </section>
      </section>
    `;
  }
}
